<template>
  <div>
    <ContentAdvisoryModal :warningText="warningText" :link="modalLink" v-show="modalWarningOn" @hide-modal="modalWarningOn = false" />
    <TheBanner />
    <IntroVideo />
    <!-- *** -->
    <main id="main" class="mu-container mu-container--main maxw-xlg pad-top--2xlg pad-bottom--4xlg">
      <div class="filters">
        <div class="filters__group">
          <h6 class="filters__heading">{{ themesFilterHeading }}</h6>
          <ul class="filter-list">
            <li class="filter-list__litem" v-for="theme in themeFilterButtons" :key="theme.id">
              <a class="filter-list__link" :class="{ 'on': theme.isActive }" :href="'#'+theme.id" @click.prevent="onFilterSelect('theme', theme.id)">
                {{ theme.text[curLang] }}
              </a>
            </li>
          </ul>
        </div>
        <div class="filters__group">
          <h6 class="filters__heading">{{ typesFilterHeading }}</h6>
          <ul class="filter-list">
            <li class="filter-list__litem" v-for="type in typeFilterButtons" :key="type.id">
              <a class="filter-list__link" :class="{ 'on': type.isActive }" :href="'#'+type.id" @click.prevent="onFilterSelect('type', type.id)">
                {{ type.text[curLang] }}
              </a>
            </li>
          </ul>
        </div>
      </div><!--/.filters-->
      <a href="#reset" @click.prevent="onFilterResetSelect()" aria-disabled="true" class="filter-reset-button inactive-button">
        <span class="frb__icon">
          <svg class="x" width="8" height="8" viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg"><path d="M5.414 4l2.121 2.121-1.414 1.414-2.121-2.121-2.121 2.121-1.414-1.414 2.121-2.121-2.121-2.121 1.414-1.414 2.121 2.121 2.121-2.121 1.414 1.414z" /></svg>
        </span>
        <span class="text">{{ clearAllFilters[curLang] }}</span>
      </a>
      <!-- *** -->
      <p class="no-results" v-if="this.numActiveCards < 1">{{ noResultsText }}</p>
      <CardsGrid :filters="this.filters.selected.themes" :types="this.filters.selected.types" v-on:show-warning-modal="activateWarningModal" :cards="cards" />
    </main>
  </div>
</template>
<script>
/* eslint-disable */
import Filters from '@/components/Filters.vue';
import Types from '@/components/Filters.vue';
import CardsGrid from '@/components/CardsGrid.vue';
import TheBanner from '@/components/TheBanner.vue';
import IntroVideo from '@/components/IntroVideo.vue';
import ContentAdvisoryModal from '@/components/ContentAdvisoryModal.vue';
import Cards from '@/data/cards/en.js';
import CardsFr from '@/data/cards/fr.js';

export default {
  /* eslint-disable */
  components: {
    Filters,
    Types,
    CardsGrid,
    TheBanner,
    IntroVideo,
    ContentAdvisoryModal,
    IntroVideo
  },
  data() {
    return {
      cards: [],
      numActiveCards: null,
      warningText: '',
      modalLink: '',
      modalWarningOn: false,
      curLang: this.$store.getters.getAppLang,
      themeFilterButtons: [],
      typeFilterButtons: [],
      filterHeadings: {
        themes: { en: 'Select a topic', fr: 'Sélectionner un sujet' },
        types: { en: 'Select a resource type', fr: 'Sélectionner un type de ressource' }
      },
      clearAllFilters: {
        en: 'Clear all filters',
        fr: 'Réinitialiser tous les filtres'
      },
      cardSections: [
        // (below) > Model accommodation should we need to repurpose this logic for section divided cards (e.g. SWW).
        { id: 'exhibitions', heading: 'Exhibitions at the Canadian War Museum', columns: 4 },
        { id: 'events-activities', heading: 'Events and Activities', columns: 3 }
      ],
      filters: {
        themes: [
          { 
            id: 113,
            text: {
              en: 'First World War', 
              fr: 'Première Guerre mondiale' 
            } 
          },
          {
            id: 214,
            text: {
              en: 'Second World War', 
              fr: 'Seconde Guerre mondiale' 
            }
          },
          {
            id: 312,
            text: {
              en: 'Peacekeeping', 
              fr: 'Maintien de la paix'
            }
          },
          {
            id: 414,
            text: {
              en: 'Afghanistan War', 
              fr: 'Guerre en Afghanistan'
            }
          },
          {
            id: 511,
            text: {
              en: 'Remembrance Day', 
              fr: 'Jour du Souvenir'
            }
          },
          {
            id: 917,
            text: {
              en: 'Indigenous Stories', 
              fr: 'Récits d’Autochtones'
            }
          },
          {
            id: 1020,
            text: {
              en: 'Black Canadian Stories', 
              fr: 'Récits de Canadiens noirs'
            }
          },
          {
            id: 1115,
            text: {
              en: 'Women\'s Stories', 
              fr: 'Récits de Canadiennes'
            }
          },
          {
            id: 1220,
            text: {
              en: 'Asian Canadian Stories', 
              fr: 'Récits de Canadiens d’origine asiatique'
            }
          },
          {
            id: 1311,
            text: {
              en: 'Veterans’ Stories', 
              fr: 'Récits de vétérans'
            }
          }
        ],
        types: [
          {
            id: 18,
            text: {
              en: 'Activity',
              fr: 'Activité'
            }
          },
          {
            id: 218,
            text: {
              en: 'Historical Overview',
              fr: 'Survol historique'
            }
          },
          {
            id: 38,
            text: {
              en: 'Artifact',
              fr: 'Artefact'
            }
          },
          {
            id: 43,
            text: {
              en: 'Art',
              fr: 'Œuvre d’art'
            }
          },
          {
            id: 58,
            text: {
              en: 'Document',
              fr: 'Document'
            }
          },
          {
            id: 610,
            text: {
              en: 'Photograph',
              fr: 'Photo'
            }
          },
          {
            id: 75,
            text: {
              en: 'Video',
              fr: 'Vidéo'
            }
          }
        ],
        selected: {
          themes: [],
          types: []
        }
      }
    };
  },
  computed: {
    noResultsText() {
      return this.curLang === 'fr' ? 'Aucun résultat.' : 'No results.';
    },
    themesFilterHeading() {
      const curLang = this.curLang;
      return this.filterHeadings.themes[curLang];
    },
    typesFilterHeading() {
      const curLang = this.curLang;
      return this.filterHeadings.types[curLang];
    },
    activeFilters() {
      return this.filters.selected;
    },
    activeThemeFilters() {
      return this.filters.selected.themes;
    },
    activeTypeFilters() {
      return this.filters.selected.types;
    }
  },
  mounted() {
    /*
    Based on the proposed CSS :focus-visible 
    pseudo-selector, this script adds a focus-visible 
    class to the focused element, in situations in 
    which the :focus-visible pseudo-selector 
    should match.
    */
    let focusVisibleScript = document.createElement('script');
    focusVisibleScript.setAttribute('src', 'https://cdn.jsdelivr.net/npm/focus-visible@5.0.2/dist/focus-visible.min.js')
    focusVisibleScript.async = true;
    document.head.appendChild(focusVisibleScript);
  },
  watch: {
    $route(to, from) {
      // react to route changes.
      // console.log('%c>>> $route(to, from) { ...', 'color:red;font-weight:bold;');
      this.setSelectedFilters();
      this.filterBtnSelToggle();
    }
  },
  created() {
    this.setFilterButtons();
    this.setCards();
    // console.log('this.cards', this.cards);
    // ***
    this.setSelectedFilters();
    this.filterBtnSelToggle();
  },
  methods: {
    setNumActiveCards() {
      const activeCards = this.cards.filter(e => e.isActive === true);
      this.numActiveCards = activeCards.length;
    },
    onFilterResetSelect() {
      const isHome = this.$router.history.current.fullPath == '/';
      if (!isHome) {
        this.$router.replace({path: '/'});
        this.setSelectedFilters();
      }
    },
    activateWarningModal(data) {
      this.warningText = data[0];
      this.modalLink = data[1];
      this.modalWarningOn = true;
    },
    setFilterButtons() {
      this.themeFilterButtons = this.filters.themes.map((theme) => {
        return { ...theme, isActive: false };
      });
      this.typeFilterButtons = this.filters.types.map((type) => {
        return { ...type, isActive: false };
      });
    },
    setCards() {
      const curLang = this.curLang;
      this.cards = curLang == 'fr' ? CardsFr : Cards;
    },
    // ***
    // ######
    // ***
    setSelectedFilters() {
      // ***
      const themeParam = this.$router.history.current.params.theme;
      const typeParam = this.$router.history.current.params.type;
      const noFilters = !typeParam && !themeParam;
      if (themeParam) {
        const routeThemeFilters = themeParam.split(',');
        const routeThemesArr = routeThemeFilters.map(el => parseInt(el));
        this.filters.selected.themes = routeThemesArr;
      }
      // ***
      if (typeParam) {
        const routeTypeFilters = typeParam.split(',');
        const routeTypeArr = routeTypeFilters.map(el => parseInt(el));
        this.filters.selected.types = routeTypeArr;
      }
      if (noFilters) {
        this.filters.selected.themes = [];
        this.filters.selected.types = [];
      }
      this.filterCards();
      //console.log('Selected Theme: ', this.filters.selected.themes[0], 'Selected Type: ', this.filters.selected.types[0], this.filters);
    },
    // ***
    // ######
    // ***
    onFilterSelect(cat, id) {
      // !! Todo: Need to document what's happening here.
      // console.log('cat', cat, '###', 'id', id);
      var selFilters = this.filters.selected;
      var pluralizedCatName = cat + 's';
      var selFilterArr = this.filters.selected[pluralizedCatName];
      
      const remItemIndex = selFilterArr.indexOf(id);

      if (!selFilters[pluralizedCatName].includes(id)) {
        selFilterArr.splice(remItemIndex, 1); // < Remove from array.
        selFilterArr.push(id);                // < Add to array, ..
      } else {
        selFilterArr.splice(remItemIndex, 1); // < Remove from array.
      }
      // ***
      this.updateRoute();
      // this.filterBtnSelToggle();
      // ^ removed on Fri Sep 4. Re-enable and troubleshoot if you experience any side effects.
    },
    // ***
    // ######
    // ***
    filterBtnSelToggle() {
      /*
      We evaluate and use router props so we bind this 
      handler more efficiently say in the created 
      lifecycle hook.
      */
      // console.log(this.$router);
      // First (1), set isActive on all (both filters) to false.
      this.themeFilterButtons.forEach(e => e.isActive = false);
      this.typeFilterButtons.forEach(e => e.isActive = false);
      // ***
      const themeParam = this.$router.history.current.params.theme;
      const typeParam = this.$router.history.current.params.type;
      // Then (2), set isActive on those that match.
      // ***
      if (themeParam) {
        var selThemeIds = themeParam.split(',');
        var selThemesArr = selThemeIds.map(el => parseInt(el));
        this.themeFilterButtons.forEach((e, index) => {
          if (selThemesArr.includes(e.id)) {
            // e.isActive = true; // < Old
            this.$set(this.themeFilterButtons[index], 'isActive', true); // < According to docs.
            // this.themeFilterButtons[index].isActive = true; // < Old
          }
        });
      } // < if (end)
      if (typeParam) {
        var selTypeIds = typeParam.split(',');
        var selTypesArr = selTypeIds.map(el => parseInt(el));
        this.typeFilterButtons.forEach((e) => {
          if (selTypesArr.includes(e.id)) {
            e.isActive = true;
          }
        });
      } // if (end)
      // ***
      this.setNumActiveCards();
    },
    // ***
    // ######
    // ***
    filterCards() {
      var cards = this.cards;
      var activeThemes = this.activeThemeFilters;
      var activeTypes = this.activeTypeFilters;
      var multiFilter = activeThemes.length > 0 && activeTypes.length > 0;
      var noFilters = activeThemes.length == 0 && activeTypes.length == 0;
      if (noFilters) {
        // If no filters, reset all isActive properties back to true.
        cards.forEach(c => c.isActive = true);
        return;
      }
      // ************************************
      cards.forEach((card, i) => {
        card.isActive = false;
        // ***
        var themeFilterMatch = false;
        var typeFilterMatch = false;
        var themes = card.cats.themes;
        var types = card.cats.types;
        themes.forEach((t) => {
          if (this.activeThemeFilters.includes(t)) {
            themeFilterMatch = true;
          }
        });
        types.forEach((t) => {
          if (this.activeTypeFilters.includes(t)) {
            typeFilterMatch = true;
          }
        });
        // ***
        // if multiple filters, match on all.
        var matchesAll = themeFilterMatch && typeFilterMatch;
        var matchOne = themeFilterMatch || typeFilterMatch;
        if (multiFilter) {
          // Multi filter mode, has to match *at least* 1 theme and 1 type.
          if (matchesAll) {
            card.isActive = true;
          }
        } else {
          // No multiple filters, still need 1 match though.
          if (matchOne) {
            card.isActive = true;
          }
        }
      });
    },
    // ***
    // ######
    // ***   
    updateRoute() {
      // Build route from selected filters.
      const themeFilters = this.activeThemeFilters;
      const strThemeFilters = themeFilters.join(',');
      const hasThemeFilter = themeFilters.length > 0;
      const typeFilters = this.activeTypeFilters;
      const strTypeFilters = typeFilters.join(',');
      const hasTypeFilter = typeFilters.length > 0;
      let routeUrl = '/';
      if (hasThemeFilter) {
        routeUrl += `theme/${strThemeFilters}/`;
      }
      if (hasTypeFilter) {
        routeUrl += `type/${strTypeFilters}/`;
      }
      // this.$router.push({ path: routeUrl });
      this.$router.replace({ path: routeUrl });
    }
  }
};
</script>